"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.timestamp('error_notified_at', {
            useTz: true
        }).nullable();
    });
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.index([
            'status',
            'error_notified_at'
        ], 'nc_automation_executions_error_notify_idx');
    });
    await knex(_globals.MetaTable.AUTOMATION_EXECUTIONS).where('status', 'error').update({
        error_notified_at: knex.fn.now()
    });
    await knex.schema.createTable(_globals.MetaTable.AUTOMATION_SUBSCRIBERS, (table)=>{
        table.string('id', 20);
        table.string('fk_workspace_id', 20);
        table.string('base_id', 20);
        table.string('fk_automation_id', 20);
        table.string('fk_user_id', 20);
        table.boolean('notify_on_error').defaultTo(true);
        table.timestamps({
            defaultToNow: true,
            useTimestamps: true
        });
        table.primary([
            'base_id',
            'id'
        ]);
    });
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_SUBSCRIBERS, (table)=>{
        table.index([
            'fk_automation_id'
        ], 'nc_automation_subscribers_automation_idx');
        table.index([
            'fk_user_id'
        ], 'nc_automation_subscribers_user_idx');
        table.unique([
            'fk_automation_id',
            'fk_user_id'
        ], {
            indexName: 'nc_automation_subscribers_unique_idx'
        });
    });
};
const down = async (knex)=>{
    await knex.schema.dropTableIfExists(_globals.MetaTable.AUTOMATION_SUBSCRIBERS);
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.dropIndex([
            'status',
            'error_notified_at'
        ], 'nc_automation_executions_error_notify_idx');
    });
    await knex.schema.alterTable(_globals.MetaTable.AUTOMATION_EXECUTIONS, (table)=>{
        table.dropColumn('error_notified_at');
    });
};
